const equals = Object.is;

function shallowEquals(x: any[], y: any[]): boolean {
  if (x.length !== y.length)
    return false;
  for (let i = 0; i < x.length; i++)
    if (!equals(x[i], y[i]))
      return false;
  return true;
}

export function memoizeOne<R, T extends (...args: any[]) => R>(f: T): T {
  let called = false;
  let lastResult: R;
  let lastArgs: any[] = [];

  const g = (...args: any[]) => {
    if (!called || !shallowEquals(args, lastArgs)){
      const result = f(...args);
      lastArgs = args;
      lastResult = result;
      called = true;
    }
    return lastResult;
  };

  return g as T;
}
